<template>
  <div class="pos-a wd-100p ht-70 zindex-99 bg-white bx-hui dp-f jus-bet">
    <div class="wd-100p dp-flex jus-c"><img class="ht-70" src="@/assets/logo.png"/></div>
    <div class="pos-a right-10 top-20" v-if="$store.state.mob" @click="clickShowMenu">
      <img v-if="display.menu" class="ht-30" src="@/assets/icon_colse.png"/>
      <img v-else class="ht-30" src="@/assets/icon_muen.png"/>
    </div>
    <!-- 手机端适配菜单 -->
    <!-- <div class="wd-60 ht-60 bg-hei1 dp-flex jus-c cr-white dp-none zindex-mob" @click="clickShowMenu">
      <img src="@/assets/icon_colse.png"/>
    </div> -->
    <div class="pos-f wd-100p ht-100p-70 top-70 bg-white all-an05 left-100p zindex-99" :class="{'left-0':display.menu}">
      <div class="mg-l-25 mg-t-20 font-18 fw">ROOM TYPES</div>
      <Menu class="wd-100p" width="100%" :open-names="['1']" accordion>
        <template v-for="(n,i) in menuList">
          <Submenu :name="i">
            <template slot="title"><span class="font-18 fw">{{n.title}}</span></template>    
            <MenuItem  v-for="(j,k) in n.list"  :name="i+'-' + k" class="Roboto" >
              <div class="wd-100p" @click="getVirtual(j)">  {{j.name}}</div>
            </MenuItem>         
          </Submenu>
          <div class="pd-l-r-25"><hr color="#eee"></div>
        </template>
      </Menu>
      <!-- <Menu class="wd-100p" width="100%">
        <MenuItem name="1">
            内容管理
        </MenuItem>
        <MenuItem name="2">
            用户管理
        </MenuItem>
        <Submenu name="3">
            <template slot="title">
                <Icon type="ios-stats" />
                统计分析
            </template>
            <MenuGroup title="使用">
                <MenuItem name="3-1">新增和启动</MenuItem>
                <MenuItem name="3-2">活跃分析</MenuItem>
                <MenuItem name="3-3">时段分析</MenuItem>
            </MenuGroup>
            <MenuGroup title="留存">
                <MenuItem name="3-4">用户留存</MenuItem>
                <MenuItem name="3-5">流失用户</MenuItem>
            </MenuGroup>
        </Submenu>
        <MenuItem name="4">
            综合设置
        </MenuItem>
      </Menu> -->
    </div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  components: { },
  data() {
    return {
      dispaly:false,
      menuList:[],
      dispaly_kids:false,
      display: {
        menu: false,
      },
    };
  },
  computed: {},
  created() {
    this.menuList = config.virtualList;
  },
  mounted() {    
    this.$store.dispatch("getMob");
  },
  watch: {},
  methods: {
    clickref(ref) {
      this.pushr(ref);
    },
    clickShowMenu() {
      this.display.menu = !this.display.menu;
      
    },
    async getVirtual(item){
      await this.$store.dispatch("getVirtualLink",item);
      this.display.menu = false;
    }
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.ivu-menu-vertical.ivu-menu-light:after{
  width:0px;
}
@media ( max-width : 768px) {
  .ht-50{
    height: 20px;
  }
}
</style>